import { render, staticRenderFns } from "./PageBuilderSettingsModal.vue?vue&type=template&id=450ed100&scoped=true"
import script from "./PageBuilderSettingsModal.vue?vue&type=script&lang=js"
export * from "./PageBuilderSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./PageBuilderSettingsModal.vue?vue&type=style&index=0&id=450ed100&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450ed100",
  null
  
)

export default component.exports